import React, { memo, useContext } from "react"
import { useTranslation } from "react-i18next"
import { type Message as MessageType } from "@/reducers/messagesSlice"

import { Message } from "@/components/ui/message/index"
import { useMessageData } from "@/components/chat/useMessageData"
import { Trash2 } from "lucide-react"
import { ChatHistoryContext } from "@/contexts/ChatHistoryContext"

type RetractedMessageProps = {
  message: MessageType
}

const RetractedMessage: React.FC<RetractedMessageProps> = ({ message }) => {
  const { t } = useTranslation()
  const messageData = useMessageData(message)
  const { isForwardingMode } = useContext(ChatHistoryContext)

  return (
    <Message
      message={message}
      variant={messageData.variant}
      showAvatar={!isForwardingMode}
    >
      <Message.Avatar
        src={messageData.avatarSrc}
        name={messageData.authorName}
        fallback={messageData.authorInitials}
        avatarColor={messageData.avatarColor}
      />

      <Message.Bubble className="border-gray-200 bg-gray-100 opacity-60 dark:border-gray-700 dark:bg-gray-800">
        <Message.Header
          author={messageData.authorName}
          timestamp={new Date(message.timestamp)}
        ></Message.Header>
        <div className="flex items-center gap-1 py-2">
          <Trash2 className="h-4 w-4" />
          <span>{t("chat.message.deleted")}</span>
        </div>
      </Message.Bubble>
    </Message>
  )
}

export default memo(RetractedMessage)
